export default [
    {
        'id': 0,
        'title': 'VS아라시',
        'title_alt': 'VS嵐',
        'date': '목요일 19:00',
        'date_week': 4,
        'date_time': '19:00',
        'type': 'television',
        'channel': '후지 TV',
        'members': [0, 1, 2, 3, 4],
    },
    {
        'id': 1,
        'title': '아라시니시야가레',
        'title_alt': '嵐にしやがれ',
        'date': '토요일 21:00',
        'date_week': 6,
        'date_time': '21:00',
        'type': 'television',
        'channel': '닛폰 TV',
        'members': [0, 1, 2, 3, 4],
    },
    {
        'id': 2,
        'title': '뉴스 제로',
        'title_alt': 'NEWS ZERO',
        'date': '월요일 23:00',
        'date_week': 1,
        'date_time': '23:00',
        'type': 'television',
        'channel': '닛폰 TV',
        'members': [1,],
    },
    {
        'id': 3,
        'title': '굿! 스포츠',
        'title_alt': 'グット！スポーツ',
        'date': '화요일 22:25',
        'date_week': 2,
        'date_time': '22:25',
        'type': 'television',
        'channel': 'NHK종합',
        'members': [2,],
    },
    {
        'id': 4,
        'title': '사쿠라이·아리요시 THE 밤연회',
        'title_alt': '櫻井・有吉THE夜会',
        'date': '목요일 22:00',
        'date_week': 4,
        'date_time': '22:00',
        'type': 'television',
        'channel': 'TBS',
        'members': [1,],
    },
    {
        'id': 5,
        'title': '아이바 마사키의 레코맨! 아라시리믹스',
        'title_alt': '嵐・相葉雅紀のレコメン！アラシリミックス',
        'date': '금요일 24:00',
        'date_week': 5,
        'date_time': '24:00',
        'type': 'radio',
        'channel': '일본문화방송',
        'members': [2,],
    },
    {
        'id': 6,
        'title': '천재! 시무라 동물원',
        'title_alt': '天才！志村どうぶつ園',
        'date': '토요일 19:00',
        'date_week': 6,
        'date_time': '19:00',
        'type': 'television',
        'channel': '닛폰 TV',
        'members': [2,],
    },
    {
        'id': 7,
        'title': '니노상',
        'title_alt': 'ニノさん',
        'date': '일요일 12:45',
        'date_week': 0,
        'date_time': '12:45',
        'type': 'television',
        'channel': '닛폰 TV',
        'members': [3,],
    },
    {
        'id': 8,
        'title': '아이바 마나부',
        'title_alt': '相葉マナブ',
        'date': '일요일 18:00',
        'date_week': 0,
        'date_time': '18:00',
        'type': 'television',
        'channel': 'TV 아사히',
        'members': [2,],
    },
    {
        'id': 9,
        'title': '베이스톰',
        'title_alt': 'BAY STORM',
        'date': '일요일 22:00',
        'date_week': 0,
        'date_time': '22:00',
        'type': 'television',
        'channel': 'bayfm',
        'members': [3,],
    },
]